import React from 'react';

import Box from '@cloudscape-design/components/box';
import Container from '@cloudscape-design/components/container';
import FormField from '@cloudscape-design/components/form-field';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';

import { ApplicationState, ToolsContent, WizardState } from '../interfaces';
import { TOOLS_CONTENT, ENVIRONMENTS, FLINK_VERSION, CHART_VERSION } from '../steps-config';
import { InfoLink } from '../../commons';
import Input from '@cloudscape-design/components/input';
import Select from '@cloudscape-design/components/select';
import { Button } from '@cloudscape-design/components';
import { toOption } from '../types';

const { details: detailsToolsContent } = TOOLS_CONTENT;
interface InstanceOptionsProps extends ApplicationState {
  setHelpPanelContent: (tools: ToolsContent) => void;
  onChange: (state: Partial<ApplicationState>) => void;
}

const InstanceOptions = ({
  organisationName,
  applicationName,
  environment,
  flink_version,
  streaming_chart_version,
  password,
  onChange,
  setHelpPanelContent,
}: InstanceOptionsProps) => {
  const validateStorageValue = (value: number, range: [number, number]) => {
    if (value === undefined) {
      return '';
    }
    if (value < range[0] || value > range[1]) {
      return 'Enter a valid storage amount.';
    }

    return '';
  };

  return (
    <Container>

      <SpaceBetween size="l">
        {/* <Button
          onClick={async () => {
            // 1️⃣ get diagnostics
            const diagRes = await fetch("http://localhost:3002/api/nl/diagnose");
            const diagData = await diagRes.json();

            const issue = diagData.diagnostics[0];
            console.log("DIAGNOSTIC:", issue);

            // 2️⃣ call fix
            const fixRes = await fetch("http://localhost:3002/api/nl/fix", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                actionHint: issue.actionHint,
                target: {
                  organisationName: "new-co",
                  applicationName: "new-app",
                  environment: "dev"
                }
              })
            });

            const fixData = await fixRes.json();

            console.log("FIX:", fixData);

            // 👉 optional: immediately apply (for demo 🔥)
            await fetch("http://localhost:3002/api/nl/apply", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                proposal: fixData.proposal
              })
            });

            alert("Fix applied 🚀");
          }}
        >
          Diagnose & Fix
        </Button> */}
      </SpaceBetween>
      <SpaceBetween size="l">
        <FormField
          label="Organisation Name"
          info={<InfoLink onFollow={() => setHelpPanelContent(detailsToolsContent.organisationName)} />}
        // description="A string that defines the name for this data-streaming instance."
        // constraintText="Must start with a letter. Must contain 1 to 64 alphanumeric characters."
        >
          <Input placeholder="example-organisation-name" value={organisationName} onChange={event => onChange({ organisationName: event.detail.value })} />
        </FormField>
        {/* </SpaceBetween>
      <SpaceBetween size="l"> */}
        <FormField
          label="Application Name"
          info={<InfoLink onFollow={() => setHelpPanelContent(detailsToolsContent.applicationName)} />}
        // description="A string that defines the name for this data-streaming instance."
        // constraintText="Must start with a letter. Must contain 1 to 64 alphanumeric characters."
        >
          <Input placeholder="example-application-name" value={applicationName} onChange={event => onChange({ applicationName: event.detail.value })} />
        </FormField>
        {/* </SpaceBetween>
      <SpaceBetween size="l"> */}
        <FormField
          label="Environment"
          info={<InfoLink onFollow={() => setHelpPanelContent(detailsToolsContent.environment)} />}
        // description="Selects the environment this application will be deployed to."
        // constraintText="Case sensitive, so stored as lower-case. Must contain from 1 to 63 alphanumeric characters or hyphens. First character must be a letter. Cannot end with a hyphen or contain two consecutive hyphens."
        >
          <Select
            options={ENVIRONMENTS}
            onChange={event => onChange({ environment: toOption(event.detail.selectedOption) })}
            selectedAriaLabel="Selected"
            selectedOption={environment}
          />
        </FormField>
        {/* <SpaceBetween size="l"> */}
        <FormField
          label="Flink version"
          info={<InfoLink onFollow={() => setHelpPanelContent(detailsToolsContent.flink_version)} />}
        // description="Selects the version of Flink this application will run on."
        // constraintText="Case sensitive, so stored as lower-case. Must contain from 1 to 63 alphanumeric characters or hyphens. First character must be a letter. Cannot end with a hyphen or contain two consecutive hyphens."
        >
          <Select
            options={FLINK_VERSION}
            onChange={event => onChange({ flink_version: toOption(event.detail.selectedOption) })}
            selectedAriaLabel="Selected"
            selectedOption={flink_version}
          />
        </FormField>
        {/* </SpaceBetween>
        <SpaceBetween size="l"> */}
        <FormField
          label="Chart version"
          info={<InfoLink onFollow={() => setHelpPanelContent(detailsToolsContent.streaming_chart_version)} />}
        // description="Selects the version of the Streaming chart"
        // constraintText="Case sensitive, so stored as lower-case. Must contain from 1 to 63 alphanumeric characters or hyphens. First character must be a letter. Cannot end with a hyphen or contain two consecutive hyphens."
        >
          <Select
            options={CHART_VERSION}
            onChange={event => onChange({ streaming_chart_version: toOption(event.detail.selectedOption) })}
            selectedAriaLabel="Selected"
            selectedOption={streaming_chart_version}
          />
        </FormField>
        <FormField
          label="SDK Password"
          info={<InfoLink onFollow={() => setHelpPanelContent(detailsToolsContent.password)} />}
          description="Generated for you. The app's Kafka user authenticates with it; nobody needs to type it."
          errorText={password ? undefined : 'Required -- with no password the Kafka user is never created and the pipeline cannot connect.'}
        // description="A string that defines the name for this data-streaming instance."
        // constraintText="Must start with a letter. Must contain 1 to 64 alphanumeric characters."
        >
          <Input type="password" placeholder="password" value={password} onChange={event => onChange({ password: event.detail.value })} />
        </FormField>
        {/* </SpaceBetween> */}
        {/* <FormField
          label="Environment"
          info={<InfoLink onFollow={() => setHelpPanelContent(detailsToolsContent.environmentName)} />}
          description="A string that defines the name for this data-streaming instance."
          constraintText="Must start with a letter. Must contain 1 to 64 alphanumeric characters."
        >
          <Input placeholder="example-environment-name" value={environmentName} onChange={event => onChange({ environmentName: event.detail.value })} />
        </FormField> */}
      </SpaceBetween>
    </Container>
  );
};
interface ApplicationProps {
  info: WizardState;
  onChange: (state: Partial<ApplicationState>) => void;
  setHelpPanelContent: (tools: ToolsContent) => void;
}

const Engine = ({ info: { application }, setHelpPanelContent, onChange }: ApplicationProps) => {
  const childProps = { ...application, setHelpPanelContent, onChange };
  return (
    <Box margin={{ bottom: 'l' }}>
      <Container header={<Header variant="h2">Application details - You are in DEV</Header>}>
        <InstanceOptions {...childProps} />
      </Container>
    </Box>
  );
};

export default Engine;
